import { createContext } from 'react';
export const StepIndicatorContext = /*#__PURE__*/createContext(undefined);
//# sourceMappingURL=StepIndicatorContext.js.map